import { type ReactNode, useCallback, useMemo } from 'react';
import {
  useLocation,
  useNavigate as useReactRouterNavigate,
} from 'react-router';
import { NavigationContext } from '@/hooks/use-navigation';

export function RouterNavigationProvider({
  children,
}: {
  children: ReactNode;
}) {
  const reactNavigate = useReactRouterNavigate();
  const { pathname } = useLocation();
  const navigate = useCallback(
    (path: string) => reactNavigate(path),
    [reactNavigate]
  );

  const value = useMemo(() => ({ navigate, pathname }), [navigate, pathname]);

  return (
    <NavigationContext.Provider value={value}>
      {children}
    </NavigationContext.Provider>
  );
}
